interface RequiredLabelProps {
  children?: React.ReactNode;
  variant?: 'required' | 'optional';
  className?: string;
}

export default function RequiredLabel({
  children = '必須',
  variant = 'required',
  className = '',
}: RequiredLabelProps) {
  const baseClasses = 'rounded-full px-3 py-1 text-xs font-bold';

  const variantClasses = {
    required: 'bg-red-50 text-red-600',
    optional: 'bg-gray-50 text-gray-500',
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${className}`}>{children}</span>
  );
}
